import React from "react";

interface EraseProps {
    // setReadOnly?: boolean;
}

//https://tabler-icons.io/i/eraser
const EraseButton: React.FC<{ onClick: () => void }> = ({onClick}) => {

    return (
        <a className="h-full min-w-[30px] max-w-[30px] flex items-center place-content-center" onClick={(e) => onClick()}>
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-eraser" width="24" height="24" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap={"round"} strokeLinejoin={"round"}>
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3"></path>
                <path d="M18 13.3l-6.3 -6.3"></path>
            </svg>
        </a>
    );
}
export default EraseButton;